<body>
    <div class="title" fxLayout="column" fxLayoutAlign="space-around center">
        <h1>A propos de moi</h1>
        <button type="button" class="btn btn-dark" (click)="openCV()" style="margin-top: 2em;">Lire mon CV</button>
        <div class="paragraph container " style="text-align: justify;display: block;padding-top: 2em;">
            J'étudie actuellement pour un <b>double diplôme</b> en <b>ingénierie informatique</b> à l'Institut Nationale
            des Sciences Appliquées (INSA) de Lyon en France et pour une <b>Maîtrise en informatique</b> avec une
            spécialisation en <b>Jeux vidéo</b> à l'Université du Québec à Chicoutimi (UQAC) au Canada.<br><br>

            Je suis une <b>passionnée de jeux vidéo et d'informatique</b> qui est actuellement en stage de <b>programmation 
                gameplay système</b> sur un jeu vidéo <b>AAA</b> non annoncé d'<b>Ubisoft Montréal !</b>
        </div>
    </div>
</body>